<div class="modal-backdrop">
  <div class="modal" [class]="modalClass">
    <app-modal-header
      [hasTour]="hasTour"
      [title]="title"
      class="w-full"
      [subtitle]="subtitle"
      [showCloseIcon]="showCloseIcon"
      (close)="onClose()"
      (tour)="onTour()"
    >
    </app-modal-header>

    <hr class="spacement" />

    <div class="modal-body" [class]="modalBodyClass">
      <ng-content></ng-content>
    </div>

    <hr class="spacement" />

    <app-modal-footer
      class="w-full"
      [primaryButtonText]="primaryButtonText"
      [secondaryButtonText]="secondaryButtonText"
      [showPrimaryButton]="showPrimaryButton"
      [showSecondaryButton]="showSecondaryButton"
      [primaryButtonVariant]="primaryButtonVariant"
      [primaryButtonId]="primaryButtonId"
      [secondaryButtonId]="secondaryButtonId"
      [primaryButtonDisabled]="primaryButtonDisabled"
      (primaryClick)="onPrimaryClick()"
      (secondaryClick)="onSecondaryClick()"
    >
    </app-modal-footer>
  </div>
</div>
